// Standalone jQuery loader - makes jQuery available globally
// This MUST load before any scripts that use jQuery
// Note: jQuery UI is NOT included here - it's loaded by page bundles that need it

import $ from "jquery"

// Make jQuery available globally for external scripts and inline code
window.$ = window.jQuery = $
